import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: "primary" | "secondary" | "danger" | "success";
	size?: "sm" | "md" | "lg";
	fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
	children,
	variant = "primary",
	size = "md",
	fullWidth = false,
	className = "",
	disabled,
	...props
}) => {
	const baseClasses =
		"font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]";
	const variantClasses = {
		primary: "bg-gradient-to-r from-primary-400 to-primary-500 hover:from-primary-500 hover:to-primary-600 text-white shadow-md hover:shadow-lg focus:ring-primary-400",
		secondary: "bg-gray-100 hover:bg-gray-200 text-gray-800 border border-gray-300 shadow-sm hover:shadow focus:ring-gray-500",
		danger: "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white shadow-md hover:shadow-lg focus:ring-red-500",
		success: "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white shadow-md hover:shadow-lg focus:ring-green-500",
	};
	const sizeClasses = {
		sm: "py-2 px-3 text-sm",
		md: "py-2.5 px-5 text-base",
		lg: "py-3 px-6 text-lg",
	};
	const disabledClasses = "disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none";
	const widthClasses = fullWidth ? "w-full" : "";

	const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${widthClasses} ${className}`;

	return (
		<button className={classes} disabled={disabled} {...props}>
			{children}
		</button>
	);
};

export default Button;
